// Extraído de App.js sem alteração de comportamento.
// Os listeners abaixo são registrados ao importar o módulo (como antes, ao carregar o App.js).
import { useState, useEffect } from "react";
import { appAlert } from "./dialog";

// ── App instalável (PWA) ──
let _installEvt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", e => { e.preventDefault(); _installEvt = e; window.dispatchEvent(new Event("g17-installable")); });
  window.addEventListener("appinstalled", () => { _installEvt = null; window.dispatchEvent(new Event("g17-installable")); });
}
export const isStandaloneApp = () => typeof window !== "undefined" && ((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true);
export const isIOSDevice = () => typeof navigator !== "undefined" && (/iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
export function useInstallApp() {
  const [, force] = useState(0);
  useEffect(() => {
    const f = () => force(x => x + 1);
    window.addEventListener("g17-installable", f);
    return () => window.removeEventListener("g17-installable", f);
  }, []);
  const can = !isStandaloneApp() && (!!_installEvt || isIOSDevice());
  const install = async () => {
    if (_installEvt) {
      const ev = _installEvt;
      ev.prompt();
      try { await ev.userChoice; } catch {}
      _installEvt = null; force(x => x + 1);
    } else if (isIOSDevice()) {
      appAlert("1. Abra o g17app.com.br no Safari.\n2. Toque em Compartilhar (o quadrado com a seta para cima).\n3. Escolha \"Adicionar à Tela de Início\" e confirme.\n\nO G17 vai aparecer como um app, em tela cheia.", { title: "Instalar o G17 no iPhone" });
    }
  };
  return { can, install };
}
